<div ngbDropdown placement="bottom-right" *ngIf="user as _user" class="kt-header__topbar-item kt-header__topbar-item--user">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper">
		<span class="kt-header__topbar-welcome">{{'AUTH.GENERAL.USER_GREETING' | translate}}</span>
		<span class="kt-header__topbar-username">{{_user.fullUserName}}</span>
		<span class="kt-header__topbar-icon"><b>{{_user.fullUserName|firstLetter}}</b></span>
	</div>
	<div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
		<!--begin: Head -->
		<div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x" 
			[ngStyle]="{ 'background-image': getBackgroundImage()}">
			<div class="kt-user-card__avatar">
				<!-- <img alt="Pic" [attr.src]="_user.pic"/> -->
				<span [hidden]="true" class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
					{{_user.fullUserName|firstLetter}}
				</span>
			</div>
			<div class="kt-user-card__name">
				{{_user.fullUserName}}
			</div>
			<!-- <div class="kt-user-card__badge">
				<span class="btn btn-success btn-sm btn-bold btn-font-md">23 messages</span>
			</div> -->
		</div>
		<!--end: Head -->

		<!--begin: Navigation -->
		<div class="kt-notification">
			<div class="kt-notification__custom flex-lg-column align-items-start">
				<mat-checkbox *ngIf="!loadingEmail else loading" 
					[checked]="authService.currentUser.emailAlerts"
					(change)="changeReceiveEmails$.next($event.checked)">
					<span>{{'AUTH.GENERAL.RECEIVE_EMAILS' | translate}}</span>
				</mat-checkbox>
				<div *ngIf="canViewPeriodicities">
					<span>
						{{'AUTH.GENERAL.RECEIVE_COI_EMAILS' | translate}}
					</span>
					<button mat-icon-button color="accent" class="" [disabled]="loadingEmail || !canViewPeriodicities"
					matTooltip="{{'PERIOD-CONFIG.DIALOG-TOOLTIP' | translate}}" (click)="editPeriodCDIWarnings()">
						<i class="material-icons md-18">edit</i>
					</button>
				</div>
				
				<ng-template #loading>
					<mat-spinner diameter="24"></mat-spinner>
				</ng-template>
			</div>
		</div>
		<div class="kt-notification">
			<div class="kt-notification__custom">
				<button mat-button (click)="downloadManual()">
					<mat-icon>get_app</mat-icon>
					{{'AUTH.GENERAL.DOWNLOAD_MANUAL' | translate}}
				</button>
			</div>
		</div>
		<div class="kt-notification">
			<!-- <a routerLink="profile" href="javascript:;" class="kt-notification__item">
				<div class="kt-notification__item-icon">
					<i class="flaticon2-calendar-3 kt-font-success"></i>
				</div>
				<div class="kt-notification__item-details">
					<div class="kt-notification__item-title kt-font-bold">
						My Profile
					</div>
					<div class="kt-notification__item-time">
						Account settings and more
					</div>
				</div>
			</a>
			<a routerLink="profile" href="javascript:;" class="kt-notification__item">
				<div class="kt-notification__item-icon">
					<i class="flaticon2-mail kt-font-warning"></i>
				</div>
				<div class="kt-notification__item-details">
					<div class="kt-notification__item-title kt-font-bold">
						My Messages
					</div>
					<div class="kt-notification__item-time">
						Inbox and tasks
					</div>
				</div>
			</a>
			<a routerLink="profile" href="javascript:;" class="kt-notification__item">
				<div class="kt-notification__item-icon">
					<i class="flaticon2-rocket-1 kt-font-danger"></i>
				</div>
				<div class="kt-notification__item-details">
					<div class="kt-notification__item-title kt-font-bold">
						My Activities
					</div>
					<div class="kt-notification__item-time">
						Logs and notifications
					</div>
				</div>
			</a>
			<a routerLink="profile" href="javascript:;" class="kt-notification__item">
				<div class="kt-notification__item-icon">
					<i class="flaticon2-hourglass kt-font-brand"></i>
				</div>
				<div class="kt-notification__item-details">
					<div class="kt-notification__item-title kt-font-bold">
						My Tasks
					</div>
					<div class="kt-notification__item-time">
						latest tasks and projects
					</div>
				</div>
			</a> -->
			<div style="padding-left: 2rem">
				{{'COMMON.VERSION' | translate}} {{version}}
			</div>

			<div class="kt-notification__custom">
				<a href="javascript:;" (click)="logout()" 
					class="btn btn-label-brand btn-sm btn-bold">
					{{'AUTH.GENERAL.LOGOUT_BUTTON' | translate}}
				</a>
			</div>
		</div>
		<!--end: Navigation -->

		<!--begin: Navigation(alternative) -->
		<ul class="kt-nav kt-margin-b-10 kt-hidden">
			<li class="kt-nav__item">
				<a routerLink="profile" class="kt-nav__link">
					<span class="kt-nav__link-icon"><i class="flaticon2-calendar-3"></i></span>
					<span class="kt-nav__link-text">My Profile</span>
				</a>
			</li>
			<li class="kt-nav__item">
				<a routerLink="profile" class="kt-nav__link">
					<span class="kt-nav__link-icon"><i class="flaticon2-browser-2"></i></span>
					<span class="kt-nav__link-text">My Tasks</span>
				</a>
			</li>
			<li class="kt-nav__item">
				<a routerLink="profile" class="kt-nav__link">
					<span class="kt-nav__link-icon"><i class="flaticon2-mail"></i></span>
					<span class="kt-nav__link-text">Messages</span>
				</a>
			</li>
			<li class="kt-nav__item">
				<a routerLink="profile" class="kt-nav__link">
					<span class="kt-nav__link-icon"><i class="flaticon2-gear"></i></span>
					<span class="kt-nav__link-text">Settings</span>
				</a>
			</li>
			<li class="kt-nav__item kt-nav__item--custom kt-margin-t-15">
				<a (click)="logout()" class="btn btn-label-brand btn-sm btn-bold">{{'AUTH.GENERAL.LOGOUT_BUTTON' | translate}}</a>
			</li>
		</ul>
		<!--end: Navigation(alternative) -->
	</div>
</div>


<!-- <a (click)="logout()" class="btn btn-label-brand btn-sm btn-bold">Sign Out</a> -->
